import { transitionEnd, bodyLock } from '../../02-tools'

let el
let navButton
let container
let subNavItems

export function Nav() {
    el = document.querySelector('.js-nav')
    if (!el) {
        return
    }

    navButton = el.querySelector('.js-nav-btn')
    container = el.querySelector('.js-nav-container')
    const subNavEls = el.querySelectorAll('.js-nav-sub-nav')
    subNavItems = Array.from(subNavEls).reduce((acc, btn) => {
        const controlId = btn.getAttribute('aria-controls')
        const container = el.querySelector('#' + controlId)

        acc[controlId] = {
            btn,
            container,
            isOpen: false,
            animationFrame: null
        }

        return acc
    }, {})

    setupEvents()
}

function setupEvents() {
    navButton.addEventListener('click', toggleNav)
    container.addEventListener('click', toggleSubnav)

    transitionEnd(container).subscribe((evt) => {
        if (!evt.target.classList.contains('c-mega-nav')) {
            return
        }

        const controlId = evt.target.id

        if (subNavItems[controlId].isOpen) {
            subNavItems[controlId].container.style.height = 'auto'
        } else {
            subNavItems[controlId].btn.setAttribute('aria-expanded', false)
            subNavItems[controlId].btn.removeAttribute('data-active')
        }
    })
}

function toggleSubnav(evt) {
    if (!evt.target.classList.contains('js-nav-sub-nav')) {
        return
    }

    const controlId = evt.target.getAttribute('aria-controls')

    if (subNavItems[controlId].isOpen) {
        closeSubnav(controlId)
    } else {
        openSubnav(controlId)
    }
}

function openSubnav(controlId) {
    if (subNavItems[controlId].animationFrame) {
        cancelAnimationFrame(subNavItems[controlId].animationFrame)
    }

    const { btn, container } = subNavItems[controlId]
    btn.setAttribute('aria-expanded', true)
    btn.dataset.active = true
    container.style.height = Math.ceil(container.scrollHeight) + 'px'
    container.dataset.active = true
    subNavItems[controlId].isOpen = true
}

function closeSubnav(controlId) {
    if (subNavItems[controlId].animationFrame) {
        cancelAnimationFrame(subNavItems[controlId].animationFrame)
    }

    const { btn, container } = subNavItems[controlId]

    btn.setAttribute('aria-expanded', false)
    btn.removeAttribute('data-active')
    container.style.height = Math.ceil(container.scrollHeight) + 'px'

    subNavItems[controlId].animationFrame = requestAnimationFrame(() => {
        container.removeAttribute('data-active')
        container.style.height = 0
        subNavItems[controlId].animationFrame = null
    })

    subNavItems[controlId].isOpen = false
}

function toggleNav() {
    if (container.dataset.active) {
        closeNav()
    } else {
        openNav()
    }
}

function closeNav() {
    navButton.setAttribute('aria-expanded', false)
    navButton.removeAttribute('data-active')
    container.removeAttribute('data-active')
    el.removeAttribute('data-active')
    bodyLock(false)
}

function openNav() {
    navButton.setAttribute('aria-expanded', true)
    navButton.dataset.active = true
    container.dataset.active = true
    el.dataset.active = true
    bodyLock(true)
}
